import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import api from '@/api/api'
// 引入elemetn-ui组件库
import ElementUI from 'element-ui';
// 引入element-ui全部css
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/reset.css'
Vue.prototype.$api=api
Vue.config.productionTip = false
// 使用element
Vue.use(ElementUI)
new Vue({
  render: h => h(App),
  router
}).$mount('#app')
